import React from 'react';

export interface FooterLeftWellProps {
  /** Content from context or undefined */
  content?: React.ReactNode;
}

/**
 * Container for left footer content (page-specific controls)
 * Renders nothing if content is undefined
 */
export function FooterLeftWell({ content }: FooterLeftWellProps): JSX.Element {
  return (
    <div className="flex-1 flex items-center gap-2 pl-4">
      {content}
    </div>
  );
}
